import { useRef, useState } from "react";
import { Pause, Play } from "lucide-react";
import { cn } from "@/lib/utils";

/** Mağaza elanları üçün video — brauzerin standart idarəetmə paneli tamamilə gizlidir. */
export function StoreVideo({
  src,
  poster,
  className,
}: {
  src: string;
  poster?: string | undefined;
  className?: string;
}) {
  const ref = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);

  const toggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const v = ref.current;
    if (!v) return;
    if (v.paused) void v.play();
    else v.pause();
  };

  return (
    <div className={cn("relative size-full overflow-hidden bg-black", className)}>
      <video
        ref={ref}
        src={src}
        poster={poster}
        playsInline
        muted
        loop
        preload="metadata"
        disablePictureInPicture
        disableRemotePlayback
        controlsList="nodownload noplaybackrate noremoteplayback nofullscreen"
        onContextMenu={(e) => e.preventDefault()}
        onClick={toggle}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        className="size-full object-cover"
      />
      <button
        type="button"
        aria-label={playing ? "Dayandır" : "Oynat"}
        onClick={toggle}
        className={cn(
          "absolute inset-0 z-10 grid place-items-center transition-opacity",
          playing ? "opacity-0 hover:opacity-100" : "opacity-100",
        )}
      >
        <span className="grid size-12 place-items-center rounded-full bg-black/55 text-white shadow-lg backdrop-blur transition-transform active:scale-90">
          {playing ? (
            <Pause className="size-5" fill="currentColor" />
          ) : (
            <Play className="ml-0.5 size-5" fill="currentColor" />
          )}
        </span>
      </button>
    </div>
  );
}